$(document).ready(function() {

	$(".steuerbuch").on('click', function(e) {
		e.preventDefault();
		if ($(".steuerbuch-chevron").hasClass("rotate")) {
			// footer wieder ausblenden
			$(".footer-dropdown").addClass("unrender");
			
			// steuerbuch wieder ausblenden
			$(".footer-steuerbuch .button-mask").addClass("unrender");
			$(".footer-dropdown-steuerbuch").addClass("unrender");
			$(".steuerbuch-chevron").removeClass("rotate");
			
			// steuerbuch mobile drodpown wieder ausblenden
			$(".footer-steuerbuch .mobile-footer-dropdown").addClass("unrender");
			$(".footer-dropdown-steuerbuch").addClass("unrender");
			$(".steuerbuch-chevron").removeClass("rotate");
		} else {
			// footer einblenden
			$(".footer-dropdown").removeClass("unrender");
			
			// information dropdown ausblenden
			$(".footer-information .button-mask").addClass("unrender");
			$(".footer-dropdown-information").addClass("unrender");
			$(".information-chevron").removeClass("rotate");
			
			// steuerbuch dropdown einblenden
			$(".footer-steuerbuch .button-mask").removeClass("unrender");
			$(".footer-dropdown-steuerbuch").removeClass("unrender");
			$(".steuerbuch-chevron").addClass("rotate");
			
			// information mobile dropdown ausblenden
			$(".footer-information .mobile-footer-dropdown").addClass("unrender");
			$(".footer-dropdown-information").addClass("unrender");
			$(".information-chevron").removeClass("rotate");
			
			// steuerbuch mobile dropdown einblenden
			$(".footer-steuerbuch .mobile-footer-dropdown").removeClass("unrender");
			$(".footer-dropdown-steuerbuch").removeClass("unrender");
			$(".steuerbuch-chevron").addClass("rotate");
		}
	});

	$(".information").on('click', function(e) {
		e.preventDefault();
			if ($(".information-chevron").hasClass("rotate")) {
				// footer wieder ausblenden
				$(".footer-dropdown").addClass("unrender");
				
				// information wieder ausblenden
				$(".footer-information .button-mask").addClass("unrender");
				$(".footer-dropdown-information").addClass("unrender");
				$(".information-chevron").removeClass("rotate");
				
				// information mobile drodpown wieder ausblenden
				$(".footer-information .mobile-footer-dropdown").addClass("unrender");
				$(".footer-dropdown-information").addClass("unrender");
				$(".information-chevron").removeClass("rotate");
			} else {
				// footer einblenden
				$(".footer-dropdown").removeClass("unrender");
				
				// steuerbuch dropdown ausblenden
				$(".footer-steuerbuch .button-mask").addClass("unrender");
				$(".footer-dropdown-steuerbuch").addClass("unrender");
				$(".steuerbuch-chevron").removeClass("rotate");
				
				// information dropdown einblenden
				$(".footer-information .button-mask").removeClass("unrender");
				$(".footer-dropdown-information").removeClass("unrender");
				$(".information-chevron").addClass("rotate");
				
				// steuerbuch mobile dropdown ausblenden
				$(".footer-steuerbuch .mobile-footer-dropdown").addClass("unrender");
				$(".footer-dropdown-steuerbuch").addClass("unrender");
				$(".steuerbuch-chevron").removeClass("rotate");
				
				// information mobile dropdown einblenden
				$(".footer-information .mobile-footer-dropdown").removeClass("unrender");
				$(".footer-dropdown-information").removeClass("unrender");
				$(".information-chevron").addClass("rotate");
			}
	});
});